<script lang="ts" setup>
import TextButton from '@/components/business/TextButton.vue'

const props = defineProps<{
  signatureRequestData?: SignatureRequestData
}>()

const { t } = useI18n()
const { downloadDocuments } = useDocumentActions()
const { mapSignatureStatus, mapSignerDisplayString } = useSignatureRequestHelpers()
const { hideDownload } = storeToRefs(useExitUrlStore())

const signersInfo = computed(() => {
  if (!props.signatureRequestData) return []
  return (
    props.signatureRequestData.signatures.map(signature => ({
      name: mapSignerDisplayString(signature),
      accountEmail: signature.accountEmail,
      status: mapSignatureStatus(signature.statusCode),
    })) || []
  )
})

const download = async () => {
  if (!props.signatureRequestData) return
  const documentIds = props.signatureRequestData.documents.map(doc => doc.versionId)
  await downloadDocuments(
    props.signatureRequestData.id,
    documentIds,
    props.signatureRequestData.statusOverall === 'SIGNED'
  )
}
</script>

<template>
  <v-row justify="space-between" align="center" class="ma-auto flex-md-nowrap">
    <strong class="h5 clipped" align="left" data-cy="sr_title">{{ signatureRequestData?.title }}</strong>
    <text-button v-if="!hideDownload" type="text" color="primary-xqes" data-cy="download_button" @click="download">
      <v-icon color="primary-xqes" size="24" class="mx-2">custom:data_download</v-icon>
      <p class="font-weight-bold">{{ t('global.download') }}</p>
    </text-button>
  </v-row>

  <skr-divider class="my-5" />
  <v-row v-for="(signer, index) in signersInfo" :key="`${signer.accountEmail}-${index}`" class="ma-auto">
    <div class="d-flex justify-space-between w-100 ga-4">
      <p color="c-grey-darker" class="clipped" :data-cy="`sr_signer_${index}`">
        {{ signer.name }}
      </p>
      <div>
        <status-chip :status="signer.status" :data-cy="`sr_status_${index}`" />
      </div>
    </div>
    <skr-divider class="my-5" />
  </v-row>
</template>

<style lang="scss" scoped>
.clipped {
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
}
</style>
